import React from 'react';
import { DatePicker, Checkbox, Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import EntityFilter from '../common/EntityFilter'
import queryString, { parse } from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import TlkTable from "../../components/tlelrik/table/tlkTable";
import $ from "jquery";
import { string } from 'prop-types';
const moment = require('moment');
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
const { Option } = Select
const InputFieldsAll = {
    DetalhesPenhora: [
        {
            key: "entidade",
            type: "info",
            display: "Entidade"
        },
        {
            key: "tipoPedidoAjuda",
            type: "info",
            display: "Tipo"
        },
        {
            key: "referencia",
            type: "info",
            display: "Refência"
        },
        {
            key: "mensagem",
            type: "info",
            display: "Mensagem"
        },
        {
            key: "utilizador",
            type: "info",
            display: "Utilizador"
        },
        {
            key: "dataCriado",
            type: "info",
            display: "Data"
        },
        {
            key: "estado",
            type: "info",
            display: "Estado"
        },
        {
            key: "anexosBox",
            type: "anexo",
            display: "Anexos"
        }
    ],
    HistoricoPedido:[{
        
            key: "historico",
            type: "grid",
            display: "Histórico"
        
    }],
    InputDetailsResposta: [
        {
            key: "RespostaInput",
            type: "textArea",
            display: "RespostaInput"
        },
        {
            key: "ComentarioInput",
            type: "text",
            display: "ComentarioInput"
        },
        {
            key: "ConfidencialInput",
            type: "checkbox",
            display: "ConfidencialInput"
        },
        {
            key: "ProximoEstadoInput",
            type: "TwoInputs",
            display: "ProximoEstadoInput"
        },
    ],
   
}

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

let tablesjson = {
    
    HistoricoPedidoAjuda: {
        columnkeyMap: {
            estado: "Estado",
            observacoes: "Observações",
            isConfidencial: "Confidencial",
            pendente: "Pendente",
            utilizadorSIVDP: "Reencaminhado para",
            criadoPor: "Utilizador",
            dataCriado: "Data"
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        notAction: false,
        totalPageHeading: "Histórico do pedido ",
        Filters: {
       
        },
        groupfield: [],
    }
}

const columnkeyMap = {
    estado: "Estado",
    observacoes: "Observações",
    isConfidencial: "Confidencial",
    pendente: "Pendente",
    utilizadorSIVDP: "Reencaminhado para",
    criadoPor: "Utilizador",
    dataCriado: "Data"
}

class PedidosAjudaFormDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error:null,
            entidade: null,
            tipo: null,
            areaTecnica: null,
            referencia: null,
            mensagem: null,
            utilizador: null,
            dataCriado: null,
            estado: null,
            RespostaInput: null,
            ComentarioInput: null,
            ConfidencialInput: false,
            ProdutosSelecionados : null,
            ProdutosFrases: [],
            PerfilIVDP: [],
            SelecaoReencaminhar: false,
            TwoInput: null,
            ReencaminharInput: null,
            idEstado: null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */
    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    });

    componentDidMount() {
        let parsed = queryString.parse(window.location.search)
        if(parsed.id){
            this.getEntidadeById(parsed.id)
        }
        

        (async () => {
            var filter={}
            const PerfilIVDP = await services.apiCall.requestApi("Transversal/GetUsersSIVDP", filter, 'get')
            this.setState({ PerfilIVDP });

            const ProdutosFrases = [{text:"Concluir", value:3}, {text:"Gravar e manter pendente", value:5}, {text:"Reencaminhar", value:2}]
            this.setState({ ProdutosFrases });

            if(parsed.id){
                var filter3={idPedidoAjuda: parsed.id}
                const Historico = await services.apiCall.requestApi("Transversal/GetHistoricoPedidosAjuda", filter3, 'get')
                this.setState({ Historico });
                
                this.getTableHistorico("Historico", Historico) 
                this.createTable("Historico", Historico)
            }
            
        })();
    }

    getTableHistorico = (type, data) => {
        if (type === "Historico") {
            var res= {}
            
            Object.keys(tablesjson.HistoricoPedidoAjuda.columnkeyMap).map((key) => {
                data.map((el) => {
                for (let index = 0; index < data.length; index++) {
                    if (key === "estado") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.estado
                                     
                    }else if (key === "dataCriado") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.dataCriado
                        ? moment(el.dataCriado).format(
                            fullDateFormat) : "nd";
                    } 
                    else if (key === "criadoPor") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.criadoPor;
                    } 
                    else if (key === "isConfidencial") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.isConfidencial ? 
                        "S" : "N"   
                    }
                    else if (key === "pendente") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.pendente ? 
                        "S" : "N"   
                    }  
                    else if (key === "utilizadorSIVDP") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.utilizadorSIVDP;
                    }
                    else if (key === "observacoes") {
                        el[tablesjson.HistoricoPedidoAjuda.columnkeyMap[key]] = el.observacoes;
                    }
                   
                }
                
            });
            
            
        });
      
        }
    };


    createTable = async (type, data) => {

        const columnlistProcessamento = Object.keys(tablesjson.HistoricoPedidoAjuda.columnkeyMap).map(function (key) {
            return { field: tablesjson.HistoricoPedidoAjuda.columnkeyMap[key], columnMenuType: "checkbox" };
        });
        if(data.length > 0){
            data = data[0]
        }
        let telkikTableProcessamento = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="HistoricoPedidoAjuda"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="HistoricoPedidoAjuda"
                // deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlistProcessamento}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTableProcessamento });

    }
	
	ActionPerform = () => { };


    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ TwoInput: e });
        if(e == 2){
            this.setState({ SelecaoReencaminhar: true });
        }else{
            this.setState({ SelecaoReencaminhar: false });
        }
    }

    handleChangeMarcaLocalizacao2 = (e) => {
        this.setState({ ReencaminharInput: e });
        // if(e == 3){
        //     this.setState({ SelecaoReencaminhar: true });
        // }else{
        //     this.setState({ SelecaoReencaminhar: false });
        // }
    }
    handleChangeTitulo = (e) => {
        this.setState({ ComentarioInput: e.value });
    }
    handleChangeCod = (e) => {
        this.setState({ cod: e.value });
    }
    handleChangeTexto = (e) => {
        this.setState({ RespostaInput: e.value });
    }
    handleCheck = (e) => {
        this.setState({ ConfidencialInput: e.currentTarget.checked });
    }
    createInputs(nevkey) {
        let inputs = InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
            case "grid":
                return(
<div>
                        <TlkTable
                            notGroup={true}
                            noDownloadButton={true}
                            pageable={false}
                            date={new Date()}
                            notAction={true}
                            noFilterShow={true}
                            forRutoloDetail={true}
                            modulename={"rotulos"}
                            list={this.state.Historico}
                            columnlist={this.columnlist}
                            ActionPerform={(action, id) =>
                                this.ActionPerform(
                                    action,
                                    id
                                )
                            }
                        />
                    </div>
                )
                    
                break;   
            case "checkbox":
                return (
                    <div className="col-md-12">
                        <div className="custom-control mt-3 custom-checkbox">
                            <input type="checkbox" onChange={(e) => this.handleCheck(e)} className="custom-control-input" id={`customCheck-${i}`} name={row.key} checked={this.state[row.key]} disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true} />
                            <label className="custom-control-label" htmlFor={`customCheck-${i}`}>{Lang.langCheck.langRequest(`${row.display}`)}</label>
                        </div>
                    </div>
                )
                break;
            case "anexo":
                return(
                <div className={"col-md-6"}>
                    <label className="principalLabel">Anexos</label>
                    <div id="anexosBox"></div>
                </div>
                )
                break;
            case "info":
                if(row.key == "dataCriado"){
                    var dateCriado = new Date(this.state[row.key])
                    var day = dateCriado.getDate() < 10 ? "0"+dateCriado.getDate() : dateCriado.getDate();
                    var month = dateCriado.getMonth() +1 < 10 ? "0"+(dateCriado.getMonth() +1) : dateCriado.getMonth() +1;
                    var year = dateCriado.getFullYear();
                    var hour = dateCriado.getHours() +":" +  dateCriado.getMinutes() +":" +  dateCriado.getSeconds()
                    dateCriado = day + "/" +  month + "/" + year + " " + hour;
                    return (
                    
                        <div className="col-md-12">
                            <label className="principalLabel">{row.display + ": "} </label>
                            <label className="secondLabel">{dateCriado}</label>
                        </div>
                        )
                }else{
                    return (
                    
                        <div className="col-md-12">
                            <label className="principalLabel">{row.display + ": "} </label>
                            <label className="secondLabel">{this.state[row.key]}</label>
                        </div>
                        )
                }
               
                break;
                case "TwoInputs":
                    return (
                        <>
                            <React.Fragment key={i}>
                                <label style={{marginLeft:"15px" , marginBottom:"0px"}}>Próximo estado</label>
                                {this.state.ProdutosSelecionados && (
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione"
                                        className="estatoSelect"
                                        mode="single"
                                        onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                        style={{ width: "100%", marginTop:"10px", marginLeft:"15px" , marginRight:"15px" }}
                                        defaultValue={this.state.ProdutosSelecionados}
                                        disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                            <Option key={index} value={item.value}>{item.text}</Option>
                                        ))}
                                    </Select>
                                )}
                                {!this.state.ProdutosSelecionados && (
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione"
                                        className="estatoSelect"
                                        mode="single"
                                        onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                        style={{ width: "100%", marginTop:"10px", marginLeft:"15px" , marginRight:"15px" }}
                                        defaultValue={this.state.ProdutosSelecionados}
                                        disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.ProdutosFrases && !!this.state.ProdutosFrases.length) && this.state.ProdutosFrases.map((item, index) => (
                                            <Option key={index} value={item.value}>{item.text}</Option>
                                        ))}
                                    </Select>
                                )}
                            </React.Fragment> 
                            {this.state.SelecaoReencaminhar == true && (
                                <React.Fragment key={i}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione"
                                        className="estatoSelect"
                                        mode="single"
                                        onChange={(e) => this.handleChangeMarcaLocalizacao2(e)}
                                        style={{ width: "100%", marginTop:"10px", marginLeft:"15px" , marginRight:"15px" }}
                                        defaultValue={this.state.ReencaminharInput}
                                        disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                    >
                                        <Option disabled>Selecione</Option>
                                        {(this.state.PerfilIVDP && !!this.state.PerfilIVDP.length) && this.state.PerfilIVDP.map((item, index) => (
                                            <Option key={index} value={item.id}>{item.fullName}</Option>
                                        ))}
                                    </Select>
                                </React.Fragment>
                            )}
                        </>
                        
                    );
                break;
                case "textArea":
                    return(
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginTop:"25px"}}>
                            <label style={{position: "absolute",zIndex: "1",top: "-12px",left: "16px",backgroundColor: "white"}} className='k-label'>{Lang.langCheck.langRequest(`${row.display}`)}</label>
                                <TextArea
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" , height: "200px",padding: "0" , paddingTop:"11px" }}
                                    className="input-1 k-textbox textareaFrases"
                                    label={Lang.langCheck.langRequest(`${row.display}`)}
                                    row={50}
                                    cols={50}
                                    value={this.state ? this.state.RespostaInput : ""}
                                    onChange={(e) => this.handleChangeTexto(e)}
                                    disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                />
                                
                            </div>
                        </div>
                    )
                break;
                case "text":
                    return (
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginBottom:0}}>
                                <Input
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    label={Lang.langCheck.langRequest(`${row.display}`)}
                                    value={this.state ? this.state.ComentarioInput : ""}
                                    onChange={(e) => this.handleChangeTitulo(e)}
                                    disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                />
                            </div>
                        </div>
                    )
                    break;
                default:
                    
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey" style={{marginBottom:0}}>
                                    <Input
                                        id={row.key}
                                        name={row.key}
                                        type={row.type}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label={Lang.langCheck.langRequest(`${row.display}`)}
                                        value={this.state ? this.state.cod : ""}
                                        onChange={(e) => this.handleChangeCod(e)}
                                        disabled={this.state.idEstado != 3 && this.state.idEstado != 4 ? false : true}
                                    />
                                </div>
                            </div>
                        )
                    
            }
        });
        return inputs
    }

    handleSelect = (value) => {
        try {
            this.setState({
                codEstatuto: value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    handleEntitySelect = (value) => {
        try {
            this.setState({
                codEntidade: +value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head" style={{marginBottom: "10px"}}>
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                       
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let parsed = queryString.parse(window.location.search)
            var data = {idPedidoAjuda: parsed.id}

            let _user = await services.apiCall.requestApi(
                "Transversal/GetPedidoAjudaDetail",
                data,
                "get"
            );
            if (_user) {
                    this.setState({
                        entidade: _user[0].entidade,
                        tipoPedidoAjuda: _user[0].tipoPedidoAjuda,
                        referencia: _user[0].referencia,
                        mensagem: _user[0].mensagem,
                        utilizador: _user[0].utilizador,
                        dataCriado: _user[0].dataCriado,
                        estado: _user[0].estado,
                        RespostaInput:  _user[0].resposta,
                        ComentarioInput:  _user[0].comentario,
                        ConfidencialInput: _user[0].isConfidencial,
                        ProdutosSelecionados: _user[0].idProximoEstado,
                        SelecaoReencaminhar : _user[0].idProximoEstado == 2 ? true : false,
                        ReencaminharInput: _user[0].idUtilizadorSIVDP,
                        idEstado : _user[0].idEstado,
                        TwoInput : _user[0].idProximoEstado,
                    })

                    var indexaMais = 0
                    
                    for (let index = 0; index < _user[0].anexos.length; index++) {
                        var imagem = _user[0].anexos[index].filePath;
                        var nome = _user[0].anexos[index].fileName;
                        var url = _user[0].anexos[index].fileName.indexOf('.png') > -1 ? "data:image/png;base64,"+ imagem : "data:application/pdf;base64,"+ imagem;
                        
                        $("#anexosBox").append('<button style="text-align: left;background-color: transparent;border: none;font-weight: 600;padding-left: 0px;" id="'+url+'" class="anexoimage ' +nome.replaceAll(' ', '')+'">'+nome+'</button>')
                        indexaMais =+ 1

                        $(".anexoimage").off("click").on("click" , function(e){
                            var pontos = e.currentTarget.classList[1].split(".");

                            if(e.currentTarget.classList[1].split(".")[pontos.length - 1] == "pdf" || e.currentTarget.classList[1].split(".")[pontos.length - 1] == "PDF"){
                                var data = e.currentTarget.id.split("data:application/pdf;base64,")[1]
                                var byteCharacters = atob(data);
                                var byteNumbers = new Array(byteCharacters.length);
                                for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                var byteArray = new Uint8Array(byteNumbers);
                                var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                                var fileURL = URL.createObjectURL(file);
                                window.open(fileURL);
                            }else{
                                var urlBase =  e.currentTarget.id
                                var image = new Image();
                                image.src = urlBase;
                                var w = window.open("");
                                w.document.write(image.outerHTML);
                            }
                        })
                    }
            }  
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {
            let parsed = queryString.parse(window.location.search)
                if(parsed.id != undefined && parsed.id != null){
                    
                    this.handleUpdatePedidoAjuda(parsed.id, backUrl);
                }
            
        } catch (error) {
            this.setState({error})
        }
    }

    handleUpdatePedidoAjuda = async (id, backUrl) => {
        try {
            if(id){
                var data = {
                    IDPedidoAjuda: id,
                    IDEstado: this.state.TwoInput,
                    IsConfidencial: this.state.ConfidencialInput,
                    Resposta: this.state.RespostaInput,
                    IDProximoEstado: this.state.TwoInput,
                    IDUtilizadorSIVDP: this.state.ReencaminharInput == "" ? null : this.state.ReencaminharInput,
                    Comentario: this.state.ComentarioInput,
                    CriadoPor:  window.localStorage.getItem('username')
                }
                var res = await services.apiCall.requestApi(`/Transversal/UpdatePedidoAjuda`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            }
            
        } catch (error) {
            this.setState({error})
        }
    }

    checkRequestData = () => {
        if(this.state.codEntidade == 0 || this.state.codEstatuto.length == 0){
            return false
        }else{
            return true
        }
    }

    handleCreateEntityEstatutoList = async (backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res ;
            let {isChecked} = this.state;
            if(isChecked || !backUrl){
            res= await services.apiCall.requestApi('/BusEntidadeEstatuto/Create', data, 'post')
            }
            if (res) {
                this.setState({
                    isChecked: false,
                })
               
            }
            if (backUrl ) {
                this.props.history.push({
                    pathname: '/entity_rule_list',
                    state:{topBarMenu : this.props.topBarMenuOption}
                })
            }
        } catch (error) {
            this.setState({error})
        }

    }

    render() {
        console.log("state",this.state)
        console.log("props",this.props)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    
                        <FormNavbar to={'/HelpDesk'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Pedido de ajuda" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">
                        
                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(PedidosAjudaFormDetails);